export default {
  BANKING: "banking",
  CUSTOMER: "customer",
  CREDIT: "credit",
  DAMAGE: "damage",
  DOSSIER: "dossier",
  INSURANCE: "insurance",
  MORTGAGE: "mortgage",
  TASK: "task",
  NOTE: "note",
};
